export default "__VITE_ASSET__yFeETYuyvPMnsvpVxNz0MQ__"